import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { Stack, Typography } from '@mui/material';
import HookFormTextField from 'src/components/hookform/HookFormTextField';
import BackButton from 'src/components/BackButton';
import SuccessButton from 'src/components/SuccessButton';

const schema = Yup.object().shape({
  name: Yup.string().trim().required('Ring name is required'),
  deferralDays: Yup.number()
    .typeError('Deferral days must be a number')
    .integer('Deferral days must be a whole number')
    .min(0, 'Deferral days must be 0 or greater')
    .required('Deferral days is required'),
});

const toDefaultValues = ring => ({
  name: ring.name,
  deferralDays: ring.deferralDays,
});

const EditDeploymentRingForm = ({ ring, isDefaultRing, loading, onCancel, onSubmit }) => {
  const formMethods = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: toDefaultValues(ring),
    resolver: yupResolver(schema),
  });

  const {
    handleSubmit,
    formState: { isValid },
  } = formMethods;

  const submit = values =>
    onSubmit({
      name: values.name.trim(),
      deferralDays: Number(values.deferralDays),
    });

  return (
    <form autoComplete="off" onSubmit={handleSubmit(submit)}>
      <Stack spacing={2} padding={2}>
        <HookFormTextField
          name="name"
          label="Ring name"
          formMethods={formMethods}
          size="small"
          fullWidth
        />
        <HookFormTextField
          name="deferralDays"
          label="Deferral days"
          formMethods={formMethods}
          type="number"
          helperText="Days the policy waits to be deployed to this ring after it is configured for deployment."
          size="small"
          fullWidth
        />
        {isDefaultRing ? (
          <Typography variant="caption" sx={{ color: '#9CA3AF' }}>
            This is the default ring. Every newly registered device will be assigned to it.
          </Typography>
        ) : null}
        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <BackButton disabled={loading} onClick={onCancel}>
            Cancel
          </BackButton>
          <SuccessButton type="submit" disabled={loading || !isValid} loading={loading}>
            Save
          </SuccessButton>
        </Stack>
      </Stack>
    </form>
  );
};

EditDeploymentRingForm.propTypes = {
  ring: PropTypes.shape({
    name: PropTypes.string,
    deferralDays: PropTypes.number,
  }).isRequired,
  isDefaultRing: PropTypes.bool,
  loading: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default EditDeploymentRingForm;
